import { CalmInterface } from './interface.js';
import { CalmControls } from './control.js';
import { CalmMetadata } from './metadata.js';
import { CalmCore } from './core.js';
import { ResolvableAndAdaptable } from './resolvable.js';
export class CalmNodeDetails {
    constructor(originalJson, requiredPattern, detailedArchitecture) {
        this.originalJson = originalJson;
        this.requiredPattern = requiredPattern;
        this.detailedArchitecture = detailedArchitecture;
    }
    toCanonicalSchema() {
        throw new Error('This should not partake or be called in the canonical form');
    }
    static fromSchema(schema) {
        return new CalmNodeDetails(schema, schema['required-pattern'] ? new ResolvableAndAdaptable(schema['required-pattern'], CalmCore.fromSchema) : undefined, schema['detailed-architecture'] ? new ResolvableAndAdaptable(schema['detailed-architecture'], CalmCore.fromSchema) : undefined);
    }
    toSchema() {
        return this.originalJson;
    }
}
export class CalmNode {
    constructor(originalJson, uniqueId, nodeType, name, description, details, interfaces, controls, metadata, additionalProperties) {
        this.originalJson = originalJson;
        this.uniqueId = uniqueId;
        this.nodeType = nodeType;
        this.name = name;
        this.description = description;
        this.details = details;
        this.interfaces = interfaces;
        this.controls = controls;
        this.metadata = metadata;
        this.additionalProperties = additionalProperties;
    }
    toCanonicalSchema() {
        const details = this.details?.detailedArchitecture?.isResolved
            ? this.details.detailedArchitecture.value.toCanonicalSchema()
            : undefined;
        return {
            'unique-id': this.uniqueId,
            'node-type': this.nodeType,
            name: this.name,
            description: this.description,
            details: details,
            interfaces: this.interfaces ? this.interfaces.map(i => i.toCanonicalSchema()) : undefined,
            controls: this.controls ? this.controls.toCanonicalSchema() : undefined,
            metadata: this.metadata ? this.metadata.toCanonicalSchema() : undefined,
            additionalProperties: this.additionalProperties || undefined
        };
    }
    static fromSchema(schema) {
        const { 'unique-id': uniqueId, 'node-type': nodeType, name, description, details, interfaces, controls, metadata, ...additional } = schema;
        return new CalmNode(schema, uniqueId, nodeType, name, description, details ? CalmNodeDetails.fromSchema(details) : undefined, interfaces ? interfaces.map(CalmInterface.fromSchema) : undefined, controls ? CalmControls.fromSchema(controls) : undefined, metadata ? CalmMetadata.fromSchema(metadata) : undefined, Object.keys(additional).length > 0 ? additional : undefined);
    }
    toSchema() {
        return this.originalJson;
    }
}
//# sourceMappingURL=node.js.map